import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArchive,
  faEllipsisVertical,
  faUserHeadset,
} from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
import { faStar as faStarSolid } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/pro-regular-svg-icons";

export type EllipsesMenuChatProps = {
  status: number;
  onArchive?: () => void;
  onPrioritize?: () => void;
  onDeprioritize?: () => void;
  onAssign?: () => void;
};

const EllipsesMenuChat: React.FC<EllipsesMenuChatProps> = ({
  status,
  onArchive,
  onPrioritize,
  onDeprioritize,
  onAssign,
}) => {
  return (
    <Menu as="div" className="relative flex-none mt-1 md:mt-0">
      <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-6 w-6"
        />
      </MenuButton>
      <MenuItems
        transition
        className="absolute md:right-0 z-50 mt-2 w-60 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <MenuItem disabled={status == 0}>
          <a
            className="flex cursor-pointer items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4"
            onClick={onArchive}
          >
            <FontAwesomeIcon icon={faArchive} />
            {t("chat.app.archive")}
          </a>
        </MenuItem>
        {status == 1 && (
          <MenuItem>
            <a
              className="flex cursor-pointer items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4"
              onClick={onPrioritize}
            >
              <FontAwesomeIcon icon={faStar} />
              {t("chat.app.mark_as_favorite")}
            </a>
          </MenuItem>
        )}
        {status == 2 && (
          <MenuItem>
            <a
              className="flex cursor-pointer items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4"
              onClick={onDeprioritize}
            >
              <FontAwesomeIcon icon={faStarSolid} />
              {t("chat.app.unmark_as_favorite")}
            </a>
          </MenuItem>
        )}
        <MenuItem>
          <a
            className="flex cursor-pointer items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4"
            onClick={onAssign}
          >
            <FontAwesomeIcon icon={faUserHeadset} />
            {t("chat.app.assign_manager")}
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuChat;
